import React, { useState } from 'react';
import { getFavouriteMatchesFromStorage, toggleFavouriteMatchInStorage } from '../data/utils';

export const FavoritesContext = React.createContext(null);

function FavoritesContextProvider(props) {
    const [context, setContext] = useState({
        favorites: getFavouriteMatchesFromStorage(),
        showFavourites: false,
        update(updt) {
            setContext(prev => {
                return {...prev, ...updt};
            });
        },
        setShowFavourites: function(showFavourites) {
            this.update({showFavourites});
        },
        toggleFavorite(match, idAggregata) {
            if (this.favorites[match.uniqueId] === undefined) {
                this.favorites[match.uniqueId] = {
                    ...match,
                    idAggregata
                };
            } else {
                delete this.favorites[match.uniqueId];
            }
            this.update({favorites: this.favorites});
            toggleFavouriteMatchInStorage(match.uniqueId, match, idAggregata);
        },
        setFavorites(favorites) {
            this.update({favorites});
        },
    });

    return (
        <FavoritesContext.Provider value={context}>
            {props.children}
        </FavoritesContext.Provider>
    );
}

export default FavoritesContextProvider;